<template>
    <div v-if="current_page">
        <ul class="ss-pagination">
            <li class="prev" :class="{disabled : (current === 1)}"><a @click.prevent="$emit('paginationChange', (current - 1) )" href="#"><i class="fa fa-angle-left"></i></a></li>
            <li class="pages"><span>{{ current }}</span> z {{ last }} stron</li>
            <li class="next" :class="{disabled : (current === last)}"><a @click.prevent="$emit('paginationChange', (current + 1) )" href="#"><i class="fa fa-angle-right"></i></a></li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "SsPagination",
        props: {
            current_page: {
                type: Number,
                default: 1
            },
            last_page: {
                type: Number,
                default: 1
            },
        },
        data(){
            return {
                current: 1,
                last: 1
            }
        },
        mounted(){
            this.current = this.current_page;
            this.last = this.last_page;
        },
        watch: {
            current_page(to){
                this.current = to;
            },
            last_page(to){
                this.last = to;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .prev, .next{
        &.disabled{
             opacity: 0.5;
        pointer-events: none;
         }
    }
</style>
